import { render, staticRenderFns } from "./VEmployerCompanyDataHistory.vue?vue&type=template&id=7345512c&lang=pug"
import script from "./VEmployerCompanyDataHistory.vue?vue&type=script&lang=ts"
export * from "./VEmployerCompanyDataHistory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports